const continentOrder = ["Europe", "North America", "South America", "Asia"];

function sortContinents(continents) {
    return continents.slice().sort((a, b) => {
        const ai = continentOrder.indexOf(a.displayName);
        const bi = continentOrder.indexOf(b.displayName);
        if (ai !== -1 && bi !== -1) return ai - bi;
        if (ai !== -1) return -1;
        if (bi !== -1) return 1;
        if (a.displayName > b.displayName) return 1;
        if (a.displayName < b.displayName) return -1;
        return 0;
    });
}

module.exports = sortContinents;